import React, { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import OpacityLoading from '../../common/loader/OpacityLoading'
import GenericModal from '../../common/modals/GenericModal';
import { getBetweenDates, editTodoAdmin } from '../../../store/reducers/todosReducer';
import { TodoCard, TodosHolder, MainDiv, GenericButton, GenericDiv, ClosenessTitle2 } from '../../common/Style';
import { GetToast } from '../../common/modals/Toast';
import { Link } from 'react-router-dom';
import ClientRoutes from '../../../navigation/Routes';
import EditGuestAdmin from './EditGuestAdmin';
import Switch from "react-switch";

const AdminTodos = () => {
    const [editTodoS, setEditTodo] = useState(false);
    const dispatch = useDispatch();
    const { todos, todosError, todosLoading } = useSelector(state => state.todosReducer);
    const { addToast } = useToasts();

    const searchGA = () => {
        let date = new Date();
        date.setHours(19);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        date.setDate(date.getDate() - 1);
        let start = date.toISOString();
        date.setDate(date.getDate() + 7);
        dispatch(getBetweenDates({ start, end: date.toISOString() })).then(res => {
            if (!res.payload?.error)
                GetToast(addToast, "success", "הפעולה בוצעה בהצלחה!!")
        })
    }

    useEffect(() => {
        if (todosError)
            GetToast(addToast, "error", todosError)
    }, [todosError]);

    const setDone = async (id, done, place, date) => {
        dispatch(editTodoAdmin(id, { done }, place, date)).then(() => {
            if (todosError === null)
                GetToast(addToast, "success", "הפעולה בוצעה")
        })
    }

    let todosArray = useMemo(() => {
        let arr = []
        if (Object.keys(todos).length > 0) {
            for (const [key, value] of Object.entries(todos)) {
                arr.push(<div style={{ width: "100%" }}><ClosenessTitle2 color={"#fda14b"} key={key}>{value[0].executionDate.replace(/T.*/, '').split('-').reverse().join('/')}</ClosenessTitle2></div>)
                for (let i = 0; i < value.length; i++)
                    arr.push(<TodoCard key={value[i]._id} style={{ cursor: "auto" }}>
                        <div className='info'>
                            <div>{value[i].uid}</div>
                            <div>{value[i].title}</div>
                            <Switch
                                width={34}
                                height={14}
                                onColor={"#fda14b"}
                                offColor={'#b1b1b1'}
                                // onHandleColor={user.color}
                                boxShadow={'0 2px 4px silver, 0 -1px 4px silver'}
                                checkedIcon={false}
                                uncheckedIcon={false}
                                checked={value[i].done}
                                onChange={() => setDone(value[i]._id, !value[i].done, i, key)}
                                handleDiameter={20}
                            />
                        </div>
                    </TodoCard>);
            }
        }
        return arr;
    }, [todos])

    return (
        <MainDiv className="animate__animated animate__fadeIn" style={{
            overflow: "hidden", maxHeight: "100vh"
        }}>

            <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", padding: `0 10px`, margin: "20px auto" }}>
                <GenericButton background={"#fda14b"} as={Link} to={ClientRoutes.Admin.main} style={{ fontSize: "14px" }}>ראשי</GenericButton>
                <GenericDiv hoverBackground={"rgb(223, 223, 223)"} background={"#fda14b"} onClick={searchGA}>ייבא</GenericDiv>
            </div>

            {/* <div style={{ marginTop: "100px" }}>
                <DropDownG label={"מיון"} data={sortOptions} value={sortBy} onChange={setSortBy} />
            </div> */}

            <TodosHolder style={{ marginTop: "0px" }}>
                {todosArray}
            </TodosHolder>


            {editTodoS && <GenericModal
                init={setEditTodo}
                div={<EditGuestAdmin data={editTodoS} init={setEditTodo} />}
            />}

            {todosLoading && <OpacityLoading />}
        </MainDiv>)
}

export default AdminTodos;